export enum StriiveJobStatusesEnum {
  UNKNOWN = 0,
  DRAFT = 1,
  OPEN = 2,
  ON_HOLD = 3,
  CHOSEN = 4,
  CLOSED = 5,
  CANCELLED = 6,
  DELETED = 7,
}

export const STRIIVE_JOB_STATUS_LABELS: Record<StriiveJobStatusesEnum, string> =
  {
    [StriiveJobStatusesEnum.UNKNOWN]: 'Unknown',
    [StriiveJobStatusesEnum.DRAFT]: 'Draft',
    [StriiveJobStatusesEnum.OPEN]: 'Open',
    [StriiveJobStatusesEnum.ON_HOLD]: 'On Hold',
    [StriiveJobStatusesEnum.CHOSEN]: 'Chosen',
    [StriiveJobStatusesEnum.CLOSED]: 'Closed',
    [StriiveJobStatusesEnum.CANCELLED]: 'Cancelled',
    [StriiveJobStatusesEnum.DELETED]: 'Deleted',
  };
